import { getFlattenOptions } from 'src/@vymo/ui/atoms/select/queries';

export const getOptionsForTreeList = (optionsList, workflowType) => {
  switch (workflowType) {
    case 'actor': {
      const tree = optionsList?.map((user) => {
        const options = getOptionsForTreeList(user?.subordinates, workflowType);
        return {
          label: user?.name,
          value: user?.code,
          options,
        };
      });
      return tree;
    }
    default:
      return [];
  }
};

export const getHierarchyOptionsForTreeList = (
  workflowType,
  userHierarchy,
  hierarchy,
) => {
  switch (workflowType) {
    case 'actor': {
      return getOptionsForTreeList([userHierarchy], workflowType);
    }
    case 'product': {
      return hierarchy.product;
    }

    case 'territory': {
      return hierarchy.territory;
    }
    default:
      return [];
  }
};

// eslint-disable-next-line max-lines-per-function
export const getColumns = (workflowType, usersList, hierarchy) => {
  switch (workflowType) {
    case 'actor': {
      return usersList?.columnConfig ?? [];
    }
    case 'product':
    case 'territory': {
      return hierarchy?.columnConfig?.[workflowType] || [];
    }
    default:
      return [];
  }
};

export const getCachedEntities = (workflowType, allUsers, hierarchy) => {
  switch (workflowType) {
    case 'actor': {
      const allUsersConfig = allUsers || {};
      const entities = Array.isArray(allUsersConfig)
        ? allUsersConfig
        : Object.values(allUsersConfig);

      return (entities || [])?.map((entity) => ({
        ...entity,
        manager: entity?.manager?.name,
        id: entity?.code,
      }));
    }
    case 'product': {
      const hierarchyData = hierarchy?.product || [];
      return getFlattenOptions(hierarchyData);
    }

    case 'territory': {
      const hierarchyData = hierarchy?.territory || [];
      return getFlattenOptions(hierarchyData);
    }
    default:
      return [];
  }
};
